import { mapDataToProperty } from 'client/contexts/Property/mappers'

export function mapProperty(data) {
  return mapDataToProperty({ ...data.property, new_path: data.new_path })
}

export function mapProperties(data) {
  return data.properties.map(property => mapDataToProperty(property))
}
